/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.invoice', [
  'data.client-invoice',
  'popup.pdf',
  'popup.invoice',
  'public.invoice.employee'
]);
